import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeProvider";
import AuthCallback from "@/pages/AuthCallback";
import Login from "@/pages/Login";
import Onboarding from "@/pages/Onboarding";
import AppShell from "@/components/AppShell";
import Today from "@/pages/Today";
import Inbox from "@/pages/Inbox";
import Tasks from "@/pages/Tasks";
import CalendarPage from "@/pages/CalendarPage";
import Week from "@/pages/Week";
import Ask from "@/pages/Ask";
import Followups from "@/pages/Followups";
import Settings from "@/pages/Settings";

const Splash = () => (
  <div className="h-screen w-full flex items-center justify-center bg-background">
    <div className="text-center animate-pulse">
      <div className="font-display text-3xl font-semibold tracking-tight">AIRTIME</div>
      <div className="text-sm text-muted-foreground mt-2">Préparation de ton espace…</div>
    </div>
  </div>
);

function Protected() {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.onboarded && location.pathname !== "/onboarding")
    return <Navigate to="/onboarding" replace />;
  return <Outlet />;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Protected />}>
        <Route path="/onboarding" element={<Onboarding />} />
        <Route element={<AppShell />}>
          <Route path="/" element={<Today />} />
          <Route path="/inbox" element={<Inbox />} />
          <Route path="/tasks" element={<Tasks />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/week" element={<Week />} />
          <Route path="/followups" element={<Followups />} />
          <Route path="/ask" element={<Ask />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" theme="dark" richColors />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
